import axios from "axios"
import { ResponseRequestGeneric } from "components/Types/GeneralTypes"
import configData from "config.json"
import { authHeader } from "helpers/auth-header"
import {  DetalleGrupoActividades, DetalleParametrosActividadesHE, DetalleParametrosDocPago, DetalleParametrosPlanificacionHE, DetalleParametrosPresupuesto, DetalleParametrosProyeccionHE, InformacionGeneralGruposActividades, InformacionGeneralParametrosHorasExtras, PostActividadHoraExtra, PostGrupoActividadesHorasExtras, PostParametrosDocPago, PutActividadHoraExtra, PutGrupoActividadHoraExtra } from "./TypesParametrosHorasExtras"
import { hadleAxiosErrorResponse } from "helpers/handle-response"

const URL_CONTROLLER_PARAMETROS = `${configData.SERVER_URL}ParametrosHorasExtras`

const URL_DETALLE_PARAMETROS_ANIO = `${URL_CONTROLLER_PARAMETROS}/DetalleParametrosProyeccion/`
// const URL_INFORMACION_GENERAL_PARAMETROS= `${URL_CONTROLLER_PARAMETROS}/InformacionGeneralParametrosProyeccionHorasExtras`
// const URL_INFORMACION_GENERAL_PARAMETROS_MENSUALES= `${URL_CONTROLLER_PARAMETROS}/InformacionGeneralParametrosPlanificacionHorasExtras`


const URL_INFORMACION_GENERAL_PARAMETROS_HORAS_EXTRAS = `${URL_CONTROLLER_PARAMETROS}/InformacionGeneralParametrosHorasExtras/`
const URL_INFORMACION_GENERAL_PARAMETROS_HORAS_EXTRAS_PROYECCION = `${URL_CONTROLLER_PARAMETROS}/InformacionGeneralParametrosHorasExtrasProyeccion/`



const URL_INFORMACION_GENERAL_PARAMETROS_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/InformacionGeneralParametrosActividades`

const URL_INFORMACION_GENERAL_PARAMETROS_GRUPOS_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/InformacionGeneralGruposActividades`


const URL_DETALLE_PARAMETROS_PLANIFICACION_ANIO = `${URL_CONTROLLER_PARAMETROS}/DetalleParametrosMensual/`

const URL_DETALLE_PARAMETRO_PRESUPUESTO = `${URL_CONTROLLER_PARAMETROS}/DetalleParametrosPresupuesto/`

const URL_CREAR_PARAMETROS = `${URL_CONTROLLER_PARAMETROS}/ParametrosProyeccion`
const URL_ACTUALIZAR_PARAMETROS = `${URL_CONTROLLER_PARAMETROS}/ParametrosProyeccion`


const URL_CREAR_PARAMETROS_PLANIFICACION = `${URL_CONTROLLER_PARAMETROS}/ParametrosPlanificacion`
const URL_ACTUALIZAR_PARAMETROS_PLANIFICACION = `${URL_CONTROLLER_PARAMETROS}/ParametrosPlanificacion`

const URL_CREAR_PARAMETRO_PRESUPUESTO = `${URL_CONTROLLER_PARAMETROS}/ParametroPresupuestoAnual`
const URL_ACTUALIZAR_PARAMETRO_PRESUPUESTO = `${URL_CONTROLLER_PARAMETROS}/ParametroPresupuestoAnual`

const URL_CREAR_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/ActividadesHorasExtras`
const URL_ACTUALIZAR_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/ActividadesHorasExtras`

const URL_DETALLE_GRUPO_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/GrupoActividadesHorasExtras/`
const URL_CREAR_GRUPO_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/GrupoActividadesHorasExtras`
const URL_ACTUALIZAR_GRUPO_ACTIVIDADES = `${URL_CONTROLLER_PARAMETROS}/GrupoActividadesHorasExtras`

const URL_DETALLE_PARAM_DOC_PAGO = `${URL_CONTROLLER_PARAMETROS}/DetalleParametroDocPago/`

const URL_CREAR_PARAM_DOC_PAGO = `${URL_CONTROLLER_PARAMETROS}/ParametroDocPago/`
const URL_ACTUALIZAR_PARAM_DOC_PAGO = `${URL_CONTROLLER_PARAMETROS}/ParametroDocPago/`


export async function ObtenerInformacionGeneralParametrosHorasExtras(tipo:"PL"|"PR" = "PL") {
    var respuesta: ResponseRequestGeneric<InformacionGeneralParametrosHorasExtras> = {
        status: -1
    };

    var URL_CONSULTA = URL_INFORMACION_GENERAL_PARAMETROS_HORAS_EXTRAS;

    if(tipo === "PR"){
        URL_CONSULTA = URL_INFORMACION_GENERAL_PARAMETROS_HORAS_EXTRAS_PROYECCION;
    }

    try {

        const responseAxios = await axios.get(URL_CONSULTA, {
            headers: authHeader()
        })

        // var responseData: InformacionGeneralParametrosHorasExtras | null = responseAxios.data;

        // if (responseData && responseData.parametrosPlanificacion && responseData.parametrosPlanificacion.mesPeriodoExtr) {
        //     var datosPlanificacion: DetalleParametrosPlanificacionHE = { ...responseData.parametrosPlanificacion };
        //     console.log("antes valor del mes",datosPlanificacion.mesPeriodoExtr)
        //     //Se ajusta el valor del mes a las necesidades de JS/TS
        //     if (datosPlanificacion.mesPeriodoExtr) {
        //         datosPlanificacion.mesPeriodoExtr = datosPlanificacion.mesPeriodoExtr - 1;
        //         responseData = { ...responseData, parametrosPlanificacion:datosPlanificacion};
        //     }
        //     console.log("despues valor del mes",datosPlanificacion.mesPeriodoExtr)



        // }

        var data: InformacionGeneralParametrosHorasExtras  = {...responseAxios.data};

        if (responseAxios.status === 200 && data) {

            if(data.parametrosProyeccion && data.parametrosProyeccion !== null){
                data.parametrosProyeccion.valoresConsultados = true;
            }
            if(data.parametrosPlanificacion && data.parametrosPlanificacion !== null){
                data.parametrosPlanificacion.valoresConsultados = true;
            }
            if(data.parametrosPresupuestoAnual && data.parametrosPresupuestoAnual !== null){
                data.parametrosPresupuestoAnual.valoresConsultados = true;
            }
            
        }


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }





    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionGeneralParametrosHorasExtras>(error)
    }

    return respuesta
}

// export async function ConsultarInformacionGeneralParametros(){
//     var respuesta:ResponseRequestGeneric<DetalleParametrosProyeccionHE>= {
//         status:-1
//     };

//     try {

//         const responseAxios = await axios.get(URL_INFORMACION_GENERAL_PARAMETROS, {
//             headers: authHeader()
//         })

//         var data:DetalleParametrosProyeccionHE|undefined = responseAxios.data;

//         if(responseAxios.status === 200 && data){
//             data.valoresConsultados = true;
//         }

//         respuesta = {
//             status : responseAxios.status,
//             dataResponse : data
//         }





//     } catch (error) {
//         respuesta = hadleAxiosErrorResponse<DetalleParametrosProyeccionHE>(error)
//     }

//     return respuesta
// }


// export async function ConsultarInformacionGeneralParametrosMensuales(){
//     var respuesta:ResponseRequestGeneric<DetalleParametrosPlanificacionHE>= {
//         status:-1
//     };

//     try {

//         const responseAxios = await axios.get(URL_INFORMACION_GENERAL_PARAMETROS_MENSUALES, {
//             headers: authHeader()
//         })

//         var data:DetalleParametrosPlanificacionHE|undefined = responseAxios.data;

//         if(responseAxios.status === 200 && data){
//             data.valoresConsultados = true;
//         }

//         respuesta = {
//             status : responseAxios.status,
//             dataResponse : data
//         }





//     } catch (error) {
//         respuesta = hadleAxiosErrorResponse<DetalleParametrosPlanificacionHE>(error)
//     }

//     return respuesta
// }


export async function ConsultarInformacionGeneralParametrosActividades() {
    var respuesta: ResponseRequestGeneric<DetalleParametrosActividadesHE> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_INFORMACION_GENERAL_PARAMETROS_ACTIVIDADES, {
            headers: authHeader()
        })

        var data: DetalleParametrosActividadesHE | undefined = responseAxios.data;



        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }





    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleParametrosActividadesHE>(error)
    }

    return respuesta
}



export async function ConsultarDetalleParametrosAnio(anio: number) {
    
    var respuesta: ResponseRequestGeneric<InformacionGeneralParametrosHorasExtras> = {
        status: -1
    };

    const URLCOMPLETA = `${URL_INFORMACION_GENERAL_PARAMETROS_HORAS_EXTRAS}${anio}`

    try {

        const responseAxios = await axios.get(URLCOMPLETA, {
            headers: authHeader()
        })

        var data: InformacionGeneralParametrosHorasExtras  = {...responseAxios.data};

        if (responseAxios.status === 200 && data) {

            if(data.parametrosProyeccion && data.parametrosProyeccion !== null){
                data.parametrosProyeccion.valoresConsultados = true;
            }
            if(data.parametrosPlanificacion && data.parametrosPlanificacion !== null){
                data.parametrosPlanificacion.valoresConsultados = true;
            }
            if(data.parametrosPresupuestoAnual && data.parametrosPresupuestoAnual !== null){
                data.parametrosPresupuestoAnual.valoresConsultados = true;
            }
            
        }


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }





    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionGeneralParametrosHorasExtras>(error)
    }

    return respuesta
}



export async function ConsultarDetalleParametrosMensualesAnio(anio: number) {
    var respuesta: ResponseRequestGeneric<DetalleParametrosPlanificacionHE> = {
        status: -1
    };
    try {

        const URL_COMPLETA = URL_DETALLE_PARAMETROS_PLANIFICACION_ANIO + anio

        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: DetalleParametrosPlanificacionHE | undefined = responseAxios.data;

        if (responseAxios.status === 200 && data) {
            data.valoresConsultados = true;
        }

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleParametrosPlanificacionHE>(error)
    }
    return respuesta
}

export async function ConsultarDetallePresupuestoAnual(anio: number) {
    var respuesta: ResponseRequestGeneric<DetalleParametrosPresupuesto> = {
        status: -1
    };
    try {

        const URL_COMPLETA = URL_DETALLE_PARAMETRO_PRESUPUESTO + anio

        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: DetalleParametrosPresupuesto | null | undefined = responseAxios.data;

        if (responseAxios.status === 200 && data) {
            data.valoresConsultados = true;
        }

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleParametrosPresupuesto>(error)
    }
    return respuesta
}

export async function ObtenerInformacionGeneralGrupoActividades(){
    var respuesta: ResponseRequestGeneric<InformacionGeneralGruposActividades> = {
        status: -1
    };
    try {


        const responseAxios = await axios.get(URL_INFORMACION_GENERAL_PARAMETROS_GRUPOS_ACTIVIDADES, {
            headers: authHeader()
        })

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionGeneralGruposActividades>(error)
    }
    return respuesta
   
    
}


export async function ConsultarDetalleGrupoActividades(){
    var respuesta: ResponseRequestGeneric<DetalleGrupoActividades[]> = {
        status: -1
    };
    try {


        const responseAxios = await axios.get(URL_DETALLE_GRUPO_ACTIVIDADES, {
            headers: authHeader()
        })

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleGrupoActividades[]>(error)
    }
    return respuesta
}

export async function ConsultarDetalleParametrosDocPago() {
    
    var respuesta: ResponseRequestGeneric<DetalleParametrosDocPago|null> = {
        status: -1
    };


    try {

        const responseAxios = await axios.get(URL_DETALLE_PARAM_DOC_PAGO, {
            headers: authHeader()
        })

       

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleParametrosDocPago>(error)
    }

    return respuesta
}


export async function CrearParametrosPeriodoAnio(nuevosParametros: DetalleParametrosProyeccionHE) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.post(URL_CREAR_PARAMETROS, nuevosParametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}


export async function CrearParametrosPlanificacion(nuevosParametros: DetalleParametrosPlanificacionHE) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.post(URL_CREAR_PARAMETROS_PLANIFICACION, nuevosParametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function CrearParametrosPresupuestoAnual(nuevosParametros: DetalleParametrosPresupuesto) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.post(URL_CREAR_PARAMETRO_PRESUPUESTO, nuevosParametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function CrearGrupoActividadHoraExtra(nuevoGrupo: PostGrupoActividadesHorasExtras) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.post(URL_CREAR_GRUPO_ACTIVIDADES, nuevoGrupo, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function CrearParametrosDocPago(nuevosParametros: PostParametrosDocPago) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.post(URL_CREAR_PARAM_DOC_PAGO, nuevosParametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}


export async function CrearActividadHoraExtra(actividades: PostActividadHoraExtra) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.post(URL_CREAR_ACTIVIDADES, actividades, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function ActualizarParametrosPeriodoProyeccionHE(parametros: DetalleParametrosProyeccionHE) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.put(URL_ACTUALIZAR_PARAMETROS, parametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function ActualizarParametrosPlanificacion(parametros: DetalleParametrosPlanificacionHE) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.put(URL_ACTUALIZAR_PARAMETROS_PLANIFICACION, parametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function ActualizarParametrosPresupuestoHE(parametros: DetalleParametrosPresupuesto) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.put(URL_ACTUALIZAR_PARAMETRO_PRESUPUESTO, parametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}


export async function ActualizarActividadHoraExtra(putActividad: PutActividadHoraExtra) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.put(URL_ACTUALIZAR_ACTIVIDADES, putActividad, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function ActualizarGrupoActividadHoraExtra(putGrupoActividad: PutGrupoActividadHoraExtra) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.put(URL_ACTUALIZAR_GRUPO_ACTIVIDADES, putGrupoActividad, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}
export async function ActualizarParametrosDocPago(nuevosParametros: PostParametrosDocPago) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {

        const responseAxios = await axios.put(URL_ACTUALIZAR_PARAM_DOC_PAGO, nuevosParametros, {
            headers: authHeader()
        });

        respuesta = {
            status: responseAxios.status,
        }




    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}